import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type RingBellIconProps = CreateIconComponentProps;
export const RingBellIcon: React.FC<RingBellIconProps> = ({
  title = 'RingBell',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10.2 6.4v-.8c0-.884.806-1.6 1.8-1.6s1.8.716 1.8 1.6v.8"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 15.68a9 9 0 0 0-18 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 18.9h18M5.5 16.4v2M19 16.4v2"
    />
  </CreateIconComponent>
);
